import { render, staticRenderFns } from "./Spear.vue?vue&type=template&id=57885a78&"
import script from "./Spear.vue?vue&type=script&lang=js&"
export * from "./Spear.vue?vue&type=script&lang=js&"
import style0 from "./Spear.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports